import { Box, Button, CircularProgress, Typography } from "@mui/material";
import ToggleButtonComponent from "../../../shared/Dashboard/ToogleButton";
import { Plus } from "lucide-react";
import { isReadOnly } from "../../../utils/permissionUtils";

const Header = ({ active, setActive, isEdit, handleClick, handleSave, btnLoader, isAdding, handleAddRow }) => {
    return (
        <Box px={2} py={2} display="flex" justifyContent="space-between" alignItems="center">
            <Box display="flex" gap={3} alignItems="center">
                <Typography variant="h6" sx={{ fontWeight: "bold", pb: 1 }}>
                    Bill of Material
                </Typography>
            </Box>

            <Box>
                <ToggleButtonComponent
                    data={["activity", "tracker_type"]}
                    active={active}
                    setActive={setActive}
                />
            </Box>

            <Box>
                {active === "activity" ?
                    <Box display="flex" gap={2} alignItems="center">
                        {!isEdit ? (
                            <Button variant="contained" onClick={handleClick} disabled={isReadOnly()}>
                                Edit
                            </Button>
                        ) : (
                            <>
                                <Button
                                    variant="contained"
                                    onClick={handleSave}
                                    disabled={btnLoader}
                                >
                                    {btnLoader ? <CircularProgress size={20} /> : "Save"}
                                </Button>
                                <Button variant="outlined" onClick={handleClick}>
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Box> :
                    <Box>
                        <Button
                            variant="contained"
                            startIcon={<Plus size={18} />}
                            onClick={handleAddRow}
                            disabled={isAdding || isReadOnly() || true}
                        >
                            Add Row
                        </Button>
                    </Box>
                }
            </Box>

        </Box>
    )
}

export default Header;